"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * TDefault class for empty menu entires
 * @class MenuItem
 */
class EmptyMenuItem {
    constructor(id, parent = null) {
        this.id = id;
        this.parent = parent;
        this.provider = null;
        this.isDisabled = false;
        this.isSelected = false;
        this.text = "";
        this.action = "";
        this.childs = [];
    }
    selectAction() {
        return __awaiter(this, void 0, void 0, function* () { return false; });
    }
}
exports.EmptyMenuItem = EmptyMenuItem;
